export default __webpack_public_path__ + "static/media/Roboto-MediumItalic.3dba85ef.ttf";